import script from "./EditorError.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditorError.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__